module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "deploy-index publish-main"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.hid
    },
    model: {
      value: (_vm.deployType),
      callback: function($$v) {
        _vm.deployType = $$v
      },
      expression: "deployType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 109002,
      "src": require('../img/7.png')
    }
  }, [_vm._v("容器化应用")]), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 109003,
      "src": require('../img/8.png')
    }
  }, [_vm._v("SAAS应用")]), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 3,
      "disabled": "",
      "src": require('../img/9.png')
    }
  }, [_vm._v("独立应用")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b6e9afc0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/publish_apply/module/deploy.vue
// module id = 1279
// module chunks = 1